import { CoinValue } from './CoinValue'
import { withCoinValue } from './withCoinValue'

const ConnectedCoinValue = withCoinValue(CoinValue)

export { ConnectedCoinValue as CoinValue }
